<div class="container">
  <div class="header-container">
    <div class="logo-container">
      <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
        <nb-icon icon="menu-2-outline"></nb-icon>
      </a>
      <img src="../../../../assets/pd/logo.png" alt="Logo" class="logo" width="250">
    </div>
    <div class="menu">
      <nb-menu [items]="menu"></nb-menu>
    </div>
    <div class="d-flex call-details">
      <nb-icon icon="phone-call-outline" class="call-icon"></nb-icon>
      <div class="d-flex flex-column pe-4 ">
        <span class="text-white">Have any questions?</span>
        <a href="tel:+91 79906 02736" target="_blank"><span class="text-warning font-weight-bold">Call: +91 79906 02736
          </span>
        </a>
      </div>
    </div>
  </div>
</div>